import { useState } from 'react';
import { MAP_VIDEO_SAMPLES } from './catalog';
import { SampleVideoPlayer } from './SampleVideoPlayer';
import { SAMPLE_DURATION_SECONDS, SAMPLE_SECTION_LABEL } from './settings';

export function MapVideoSamples() {
  const [selected, setSelected] = useState(MAP_VIDEO_SAMPLES.find(map => map.id === 'relief')!);
  const cameraLabel = selected.id === 'blackbird' ? 'Blackbird' : 'Night Stalker';
  return <section id="maps" className="sample-map-gallery" aria-labelledby="map-sample-heading">
    <div className="sample-section-heading"><span className="eyebrow">Every map, in motion</span>
      <h2 id="map-sample-heading">{MAP_VIDEO_SAMPLES.length} maps.</h2>
    </div>
    <div className="sample-map-choices" role="group" aria-label="Map video previews">
      {MAP_VIDEO_SAMPLES.map(map => <button key={map.id} type="button" aria-pressed={selected.id === map.id}
        onClick={() => setSelected(map)}>{map.label}</button>)}
    </div>
    <p className="sample-map-caption">{selected.label} map · {cameraLabel} Camera Platform · {SAMPLE_DURATION_SECONDS} seconds · {selected.output.width} × {selected.output.height}</p>
    <SampleVideoPlayer key={selected.id} src={selected.src} width={selected.output.width} height={selected.output.height}
      label={selected.label} description={`${selected.label} map preview of ${selected.id === 'relief' ? 'a 3.83-mile path from Times Square to the World Trade Center' : `a ${SAMPLE_SECTION_LABEL}`}`} />
  </section>;
}
